import { render, staticRenderFns } from "./DirectInvestmentValuation.vue?vue&type=template&id=12a4f691"
import script from "./DirectInvestmentValuation.vue?vue&type=script&lang=js"
export * from "./DirectInvestmentValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports